/**
 * Hub-level sku category names for the customer platform bundle.
 *
 * These are the six hub product categories that appear in the customer
 * platform bundle pricing page (suite page). The constants live here;
 * the type is re-exported from the feature-display types to avoid
 * duplication.
 */

export const CUSTOMER_PLATFORM_BUNDLE_SKU_CATEGORY_NAMES = ['MARKETING_PRODUCTS', 'SALES_PRODUCTS', 'SERVICE_HUB_PRODUCTS', 'CMS_HUB_PRODUCTS', 'OPERATIONS_HUB_PRODUCTS', 'COMMERCE_PRODUCTS'];
export const VALID_CUSTOMER_PLATFORM_BUNDLE_SKU_CATEGORY_NAMES = new Set(CUSTOMER_PLATFORM_BUNDLE_SKU_CATEGORY_NAMES);